import { StructureService } from '../services/structure.service';
import { AbstractControl, ValidationErrors, ValidatorFn, UntypedFormArray, AsyncValidatorFn } from '@angular/forms';
import { timer, of, Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { DisplayStructure } from '../models/displayStructure';

export class StructureValidators {
  public static uniqueIdIODAS(structureService: StructureService, previousValue: string | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const idIODAS: string = control.value;
      const isUniqueIdIODAS: boolean = structureService.displayStructures
        .map((structure: DisplayStructure) => structure.idIODAS)
        .filter((value: string) => value !== previousValue)
        .some((value: string) => value === idIODAS);

      return !isUniqueIdIODAS ? null : { unavailable: true };
    };
  }

  public static uniqueLabel(structureService: StructureService, previousValue: string | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const label: string = control.value;
      const isUniqueLabel: boolean = structureService.displayStructures
        .map((structure: DisplayStructure) => structure.label)
        .filter((value: string) => value !== previousValue)
        .some((value: string) => value === label);

      return !isUniqueLabel ? null : { unavailable: true };
    };
  }

  public static get uniqueSupportPlace(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof UntypedFormArray)) {
        return null;
      }

      const controls: AbstractControl[] = control.controls.filter(
        (formGroup: AbstractControl, index: number) =>
          control.controls.findIndex(
            (searchFormGroup: AbstractControl) =>
              formGroup.get('cliId').value === searchFormGroup.get('cliId').value &&
              formGroup.get('supportTypeId').value === searchFormGroup.get('supportTypeId').value,
          ) !== index,
      );
      const isUnique: boolean = controls && controls.length > 0;

      return !isUnique ? null : { unavailable: true };
    };
  }
}
